import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-462ee02a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "min-h-[calc(100vh-60px)] flex flex-col w-full pb-20 px-[5%] tablet:items-start laptop:flex-row-reverse gap-5 py-10 laptop:py-0" }
const _hoisted_2 = { class: "text-black w-full laptop:w-3/4 flex flex-col items-center laptop:my-10" }
const _hoisted_3 = { class: "w-full p-5 text-lg font-semibold flex flex-col laptop:items-start" }
const _hoisted_4 = { class: "w-full flex flex-col items-start" }

import {ref} from "vue";
import {ProClenyButton} from "@/interfaces/enums";
import AktualniInformace from "@/components/ProCleny/AktualniInformace.vue";
import UzitecneDokumenty from "@/components/ProCleny/UzitecneDokumenty.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const activeBtn = ref<ProClenyButton>(ProClenyButton.aktualniInfo)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UzitecneDokumenty, { class: "w-full h-full laptop:w-1/4 laptop:h-[calc(100vh-60px)] laptop:flex laptop:justify-center laptop:sticky laptop:top-0" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(activeBtn.value), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(AktualniInformace, { class: "contentBox" })
      ])
    ])
  ]))
}
}

})